export class PreVote {
    PEID: number;
    CSID: string;
    Mapping: string;
    CheckField: boolean;
    IsChanged: boolean;

}
